import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { generalGetFunction, generalPostFunction } from "../Globals/globalFunctions";
import { toast } from "react-toastify";
import { SvgIcon } from "../Components/SvgIcons";

function MacIdApprovals() {
	const navigate = useNavigate();
	const [allMacIdRequests, setAllMacIdRequests] = useState([]);

	const getAllMacIdRequests = async () => {
		const response = await generalGetFunction("/macidoperation", "3040");

		if (response) {
			setAllMacIdRequests(response);
		}
	};

	useEffect(() => {
		getAllMacIdRequests();
	}, []);

	const approveRequest = async (item) => {
		const payload = {
			username: item.username,
		};
		const response = await generalPostFunction(`/macidoperation/approve`, payload, "3040");
		if (response) {
			toast.success("Mac ID Approved Successfully!");
			getAllMacIdRequests();
		}
	};

	const disapproveRequest = async (item) => {
		const payload = {
			username: item.username,
		};
		const response = await generalPostFunction(`/macidoperation/disapprove`, payload, "3040");
		if (response) {
			toast.success("Mac ID Request Disapproved!");
			getAllMacIdRequests();
		}
	};

	return (
		<div className="overviewTableWrapper">
			<div className="overviewTableChild">
				<div className="d-flex flex-wrap">
					<div className="col-12">
						<div className="heading">
							<div className="content">
								<h4>
									MacID Approvals{" "}
									<button className="clearButton">
										<SvgIcon name="refresh" />
									</button>
								</h4>
							</div>
							<div className="buttonGroup">
								<button className="panelButton gray" onClick={() => navigate(-1)}>
									<span className="text">Back</span>
									<span className="icon">
										<SvgIcon name="back" />
									</span>
								</button>
								<button className="panelButton" onClick={getAllMacIdRequests}>
									<span className="text">Refresh</span>
									<span className="icon">
										<SvgIcon name="refresh" />
									</span>
								</button>
							</div>
						</div>
					</div>
					<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
						<div className="tableContainer">
							<table>
								<thead>
									<tr>
										<th>#</th>
										<th>Username</th>
										<th>Current Mac ID</th>
										<th>Requested Mac ID</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									{allMacIdRequests && allMacIdRequests.length > 0 ? (
										allMacIdRequests.map((item, index) => {
											return (
												<tr>
													<td>{index + 1}</td>
													<td>{item.username}</td>
													<td>{item.usermacid}</td>
													<td>{item.requestedmacid}</td>
													<td>
														<div className="d-flex justify-content-end">
															<button className="tableButton edit me-2" onClick={() => approveRequest(item)}>
																<SvgIcon name="check" />
															</button>
															<button className="tableButton delete" onClick={() => disapproveRequest(item)}>
																<SvgIcon name="xmark" />
															</button>
														</div>
													</td>
												</tr>
											);
										})
									) : (
										<tr>
											<td colSpan={99}>No Data Found!</td>
										</tr>
									)}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default MacIdApprovals;
